import * as React from "react";
import styled from "styled-components";

import { IconCaret } from "../../../../components/atoms";
import { Input } from "../../../../components/molecules/input";

interface IProps {
  inputRef: React.RefObject<HTMLInputElement>;
  onClick(): void;
  children?: React.ReactNode;
}

const SearchDateWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 50%;

  input {
    border-right: 0;
    border-radius: 20px 0 0 20px;
    cursor: pointer;
  }
`;

const SearchDateCaret = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  right: 15px;
  width: 9px;
  transform: translate(0, -50%);
  pointer-events: none;
`;

const SearchDate: React.FC<IProps> = (props) => {
  return (
    <SearchDateWrapper>
      <Input
        readOnly
        inputStyle="round"
        placeholder="Date"
        innerRef={props.inputRef}
        onClick={props.onClick}
      />
      {props.children}
      <SearchDateCaret>
        <IconCaret />
      </SearchDateCaret>
    </SearchDateWrapper>
  );
};

export { SearchDate };
